import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorMessageService {
  errorMessages = new BehaviorSubject<Array<string>>([]);

  constructor() {}

  addToErrorMessages(message: string) {
    const messages = this.errorMessages.value;

    if (!messages.includes(message)) {
      messages.push(message);
    }

    this.errorMessages.next(messages);
  }

  clearErrorMessages() {
    this.errorMessages.next([]);
  }

  clearIndividualMessage(message: string) {
    let messages = this.errorMessages.value;

    messages = messages.filter((error: string) => error !== message);

    this.errorMessages.next(messages);
  }
}
